import {
  getPlayerLevelNameLayout,
  getPlayerLevelNameLines,
} from './playerLevelNameLayouts';

type PlayerLevelNameTextProps = {
  /** Level name; line breaks come from layout / width wrap (Figma text box). */
  name?: string;
};

const DEFAULT_NAME = 'Тучка на побегушках';

/** Figma Group 1321317994 (188:9318) — Matias 35, stroke #4D3C82. */
export function PlayerLevelNameText({
  name = DEFAULT_NAME,
}: PlayerLevelNameTextProps) {
  const layout = getPlayerLevelNameLayout(name);
  const lines = getPlayerLevelNameLines(name, layout);

  const midX = layout.width / 2;
  const firstBaseline = 32;
  const lineHeight = 41;

  return (
    <svg
      className="player-level-screen-button__name"
      width={layout.width}
      height={layout.height}
      viewBox={`0 0 ${layout.width} ${layout.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{
        left: layout.left,
        top: layout.top,
        width: layout.width,
        height: layout.height,
      }}
    >
      <text
        className="player-level-screen-button__name-text"
        textAnchor="middle"
        xmlSpace="preserve"
      >
        {lines.map((line, index) => (
          <tspan key={index} x={midX} y={firstBaseline + index * lineHeight}>
            {line}
          </tspan>
        ))}
      </text>
    </svg>
  );
}
